export const version = "networks/5.6.0";
//# sourceMappingURL=_version.js.map